import React, { useState, useRef, useMemo } from "react";
import { observer } from "mobx-react";
import { Autocomplete, Select, Button } from "@ann/web-components";
import {
  FiltersContainer,
  SearchContainer
} from "./Filters.styled";

const Filters = observer(() => {
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState(0);
  const [searchTermState, setSearchTermState] = useState("");
  const [searchTermLastUpdate, setSearchTermLastUpdate] = useState("");
  const [filtersKey, setFiltersKey] = useState(0);
  const autocompleteRef = useRef(null);

  // Filter options
  const stateOptions = [
    { label: "Sent", value: "sent" },
    { label: "Delivered", value: "delivered" },
    { label: "Read", value: "read" },
    { label: "Failed", value: "failed" },
    { label: "Bounced", value: "bounced" },
    { label: "Spam", value: "spam" },
    { label: "Draft", value: "draft" },
    { label: "Scheduled", value: "scheduled" },
  ];

  const lastUpdateOptions = [
    { label: "Last 7 days", value: "last_7_days" },
    { label: "Last 30 days", value: "last_30_days" },
    { label: "This month", value: "this_month" },
    { label: "This year", value: "this_year" },
  ];

  // Filtered options based on search terms
  const filteredState = useMemo(() => {
    if (!searchTermState.trim()) return stateOptions;
    const searchLower = searchTermState.toLowerCase();
    return stateOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermState]);

  const filteredLastUpdate = useMemo(() => {
    if (!searchTermLastUpdate.trim()) return lastUpdateOptions;
    const searchLower = searchTermLastUpdate.toLowerCase();
    return lastUpdateOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermLastUpdate]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    // Here you can add your search logic or call a callback function
    // to update the parent component's state
  };

  const handleSearchClear = () => {
    setSearchValue("");
    setSearchKey((prev) => prev + 1);

    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const handleStateChange = (items) => {
    // Handle state filter changes
    console.log("State filter changed:", items);
  };

  const handleLastUpdateChange = (items) => {
    // Handle last update filter changes
    console.log("Last update filter changed:", items);
  };

  const handleClearAllFilters = () => {
    setSearchValue("");
    setSearchTermState("");
    setSearchTermLastUpdate("");
    setSearchKey((prev) => prev + 1);
    setFiltersKey((prev) => prev + 1);

    // Clear autocomplete input
    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  };

  const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

  return (
    <FiltersContainer>
      <SearchContainer>
        <Autocomplete
          key={searchKey}
          ref={autocompleteRef}
          value={searchValue}
          onChange={handleSearchChange}
          onSearch={() => { }}
          onSuggestionSelect={() => { }}
          onClear={handleSearchClear}
          placeholder="Search emails..."
          suggestions={[
            "Incoming email",
            "Outgoing email",
            "Support email",
            "Marketing email",
            "Newsletter",
            "Invoice email",
            "Confirmation email",
          ]}
        />
      </SearchContainer>
      <Select
        key={`state-filter-${filtersKey}`}
        label="State"
        placeholder="State"
        onChange={handleStateChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredState.map((state) => (
            <Select.Item
              key={state.value}
              value={state.value}
              label={state.label}
            >
              {state.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Select
        key={`last-update-filter-${filtersKey}`}
        label="Last Update"
        placeholder="Last Update"
        onChange={handleLastUpdateChange}
        size="small"
        value={undefined}
        width="auto"
        minWidth="60px"
      >
        <Select.Menu>
          {filteredLastUpdate.map((option) => (
            <Select.Item
              key={option.value}
              value={option.value}
              label={option.label}
            >
              {option.label}
            </Select.Item>
          ))}
        </Select.Menu>
      </Select>
      <Button
        icon=""
        iconLeft=""
        iconRight=""
        label="Clear Filters"
        size="medium"
        type="secondary"
        onClick={handleClearAllFilters}
      />
    </FiltersContainer>
  );
});

export default Filters; 